module.exports = __webpack_public_path__ + "fonts/KrungthaiFastWeb-ExtraBold.43c176be.woff";